module.exports = __webpack_public_path__ + "img/face-grin-wink.49ba4584.svg";